module.exports = __webpack_public_path__ + "res/img_flip_counter.1be65610208534b8199cac5c93b485ef.png";